export const PRIMARY_COLOR = '#FF7901';
